module.exports = __webpack_public_path__ + "static/media/pf_item_43.3e3aecd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pf_item_43.jpg
// module id = 146
// module chunks = 0